<div class="section-editor-layout">
  <aside class="section-menu">
    <button type="button" mat-stroked-button color="primary" class="add-section-btn" (click)="addSection()">
      <mat-icon>add</mat-icon>
      {{ 'help-section-add' | translate }}
    </button>

    <div class="section-list">
      @for (section of sortedSections; track section.id) {
        <div class="section-row" [class.active]="section.id === activeSectionId">
          <div class="reorder-col">
            <button
              type="button"
              mat-icon-button
              class="reorder-btn"
              [disabled]="isFirst(section)"
              matTooltip="{{ 'help-section-move-up' | translate }}"
              (click)="moveSectionUp(section, $event)"
            >
              <mat-icon>keyboard_arrow_up</mat-icon>
            </button>
            <button
              type="button"
              mat-icon-button
              class="reorder-btn"
              [disabled]="isLast(section)"
              matTooltip="{{ 'help-section-move-down' | translate }}"
              (click)="moveSectionDown(section, $event)"
            >
              <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
          </div>

          <button type="button" class="section-title-btn" (click)="selectSection(section)">
            {{ section.title | translate }}
          </button>

          <div class="section-actions">
            <button
              type="button"
              mat-icon-button
              matTooltip="{{ 'help-section-rename' | translate }}"
              (click)="renameSection(section, $event)"
            >
              <mat-icon fontSet="material-symbols-outlined">edit</mat-icon>
            </button>
            <button
              type="button"
              mat-icon-button
              matTooltip="{{ 'help-section-delete' | translate }}"
              (click)="deleteSection(section, $event)"
            >
              <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
            </button>
          </div>
        </div>
      } @empty {
        <p class="section-list-empty">{{ 'help-section-empty' | translate }}</p>
      }
    </div>
  </aside>

  <main class="section-editor-main">
    @if (hasSections && activeSectionId && isLayoutReady) {
      <ckeditor
        [editor]="editor"
        [config]="editorConfig"
        [formControl]="sectionContentControl"
        (ready)="onEditorReady($event)"
        (change)="onEditorContentChange()"
      >
      </ckeditor>
    } @else {
      <div class="editor-placeholder">
        <p>{{ 'help-section-select' | translate }}</p>
      </div>
    }
  </main>
</div>
